
















import { Component, Prop, Vue } from 'vue-property-decorator';

import { eventWebservice } from '../../webservices/event'
import { statusWebservice } from '../../webservices/status'

import { Getter } from 'vuex-class'

import Newest from './newest/Newest.vue'
import Create from './create/Create.vue'


@Component({
    name:'Manage',
    components: {
        Newest,
        Create,
    }
})

export default class Manage extends Vue {

    // Data
    public loadedStatus: boolean = false;
    public loadedNewestEvent: boolean = false;

    @Getter('account/loggedIn') loggedIn

    // Mounted is called initially
    mounted() {
        let self = this

        if(this.loggedIn) {
            // Fetch all status
            statusWebservice.getAllStatus().then(function(status) {
                // Store in vuex
                self.$store.commit('status/setStatus', status)
                self.loadedStatus = true;
            }).catch(function (error) {
                console.log("Error")
            })

            // Fetch newest event
            eventWebservice.getNewestEvent().then(function(event) {
                // Store in vuex
                self.$store.commit('event/setNewestEvent', event)
                self.loadedNewestEvent = true;
            })
        } else {
            // Not logged in, redirect to login
            this.$router.push('auth/login')
        }
    }

    logout() {
         this.$router.push('auth/logout')
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/events/Manage.vue